// i18n area 'common' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.sv-SE.meta.json.
import type { enUS } from './common'

export const svSE: typeof enUS = {
  nav: {
    home: 'Hem',
    vms: 'Virtuella maskiner',
    templates: 'Templates',
    importVms: 'Importera VM',
    containers: 'Containrar',
    containersApps: 'Appar',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-avbilder',
    containersOciRegistries: 'OCI-registries',
    containersCtTemplates: 'CT-templates',
    networkServices: 'Nätverkstjänster',
    firewall: 'Brandvägg',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Övervakning',
    cluster: 'Kluster',
    clusterSettings: 'Globala inställningar',
    clusterNodes: 'Noder',
    clusterDevices: 'USB- och PCIe-resurser',
    clusterFederation: 'Federation',
    network: 'Nätverk',
    overlayNetworks: 'Overlay-nätverk',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Data',
    storages: 'Storage',
    hci: 'Hyperkonvergens',
    ceph: 'Ceph',
    system: 'System',
    tasks: 'Tasks',
    events: 'Händelser',
    audit: 'Audit',
    diagnostics: 'Diagnostik',
    notifications: 'Notifieringar',
    proximity: 'TVirt Proximity',
    users: 'Användare och grupper',
    groups: 'Grupper',
    mfa: 'MFA',
    realms: 'Realm och SSO',
    rbac: 'Roller och behörigheter',
    credentials: 'Autentiseringsuppgifter',
    scopes: 'Scope',
    tags: 'Taggar',
    explorer: 'Utforska',
    licensing: 'Licens',
    information: 'Information'
  },
  mode: {
    light: 'Ljust',
    dark: 'Mörkt',
    system: 'System',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Språk'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Nordamerika',
    southAmerica: 'Sydamerika',
    asia: 'Asien'
  },
  notFound: {
    title: 'Sidan hittades inte',
    body: 'Den här adressen motsvarar ingen sida i TVirt — den kan ha flyttat med en uppdatering, eller så är länken gammal.',
    backHome: 'Tillbaka till Hem'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Hela klustret',
    noChildren: 'Inga under-scope här',
    recursive: 'Inkludera underordnade',
    collapse: 'Fäll ihop scope-panelen',
    openPicker: 'Utforska scopen',
    up: 'Gå upp en nivå',
    countTooltip: '{direct} i detta scope · {total} med underordnade'
  },
  search: {
    tooltip: 'Sök (⌘K)',
    placeholder: 'Sök VM, nätverk, storage…',
    empty: 'Inga resultat',
    groups: {
      recent: 'Senaste',
      shortcuts: 'Genvägar',
      actions: 'Åtgärder',
      goTo: 'Gå till'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Nod'
    },
    footer: {
      navigate: 'navigera',
      open: 'öppna',
      close: 'stäng'
    },
    actions: {
      createVm: 'Skapa VM…',
      uploadIso: 'Ladda upp ISO…',
      clusterSettings: 'Klusterinställningar',
      consoleOf: 'Gå till konsolen för {name}'
    }
  },
  stub: {
    containersSummary: 'Applikationer och systemcontainrar (CT), med deras OCI-avbilder, registries och templates — hanterade bredvid dina VM.',
    sectionSummary_vms: 'Virtuella maskiner och deras templates — livscykel, snapshots, migrering och konsol.',
    sectionSummary_storages: 'Storagen där VM:arnas diskar, avbilder och metadata bor.',
    sectionSummary_catalogs: 'Hemmet för klustrets filartefakter: ISO-avbilder, CT- och VM-templates och OCI-arkiv, organiserade i kataloger.',
    sectionSummary_overlay: 'VXLAN-overlay-nätverk mellan klustrets noder.',
    sectionSummary_fabric: 'Det fysiska nätverkets inventarium — switchar, portar, LAGG och logiska nätverk.',
    sectionSummary_ipam: 'Adresseringen härledd från fabric- och overlay-näten: vem som håller varje adress.',
    sectionSummary_services: 'DHCP- och DNS-servrar härledda från nätverksregistret.',
    sectionSummary_ceph: 'Ceph-kluster hanterade på TVirt-noderna.',
    sectionSummary_hci: 'De hyperkonvergerade storage-teknikerna på TVirt-noderna.',
    sectionSummary_cluster: 'Noder, medlemskap och klusterinställningar.',
    containers: 'Systemcontainrarna är på roadmapen — den här sektionen kommer att husera dem.',
    containersApps: 'De containeriserade applikationerna är på roadmapen — det här området kommer att husera dem.',
    containersPods: 'Pods grupperar containrar som delar nätverk och volymer — instanserna är apparna.',
    containersCt: 'Systemcontainrarna (CT) är på roadmapen — det här området kommer att husera dem.',
    multiscsi: 'TVStor MultiSCSI är på roadmapen — det här området kommer att husera det.',
    clusterFederation: 'Federationen mellan TVirt-kluster är på roadmapen — det här området kommer att husera den.',
    containersOciImages: 'OCI-avbilderna är på roadmapen — det här området kommer att husera dem.',
    containersOciRegistries: 'OCI-registryerna är på roadmapen — det här området kommer att husera dem.',
    containersCtTemplates: 'CT-templaterna är på roadmapen — det här området kommer att husera dem.',
    importVms: 'ESXi- och Proxmox-importrarna kommer hit: konvertering av guests och massmigrering in i TVirt.',
    backup: 'Den integrerade backupen kommer med 6.2: deduplicerade content-addressed repositories, CBT-inkrementeller, immutabilitetsfönster och repo-till-repo-replikering.',
    monitoring: 'Klusteromfattande dashboards för resurskonkurrens (cpu.ready, PSI-tryck, inbyggda alerts) är på väg — i dag bor samma mätvärden i varje VM:s detaljvy.'
  },
  home: {
    welcome: 'Du är inloggad som: {name}',
    subtitle: 'Här är ditt TVirt-kluster i ett ögonkast.',
    loadError: 'Kunde inte läsa in översikten — är TVirt-backenden nåbar?',
    health: {
      ok: 'Allt i sin ordning',
      warning: 'Uppmärksamhet',
      critical: 'Kritiska problem'
    },
    reason: {
      'node-down': '{subject} är avstängd',
      'node-stale': '{subject} har inte hörts av på ett tag',
      'node-maintenance': '{subject} i underhåll',
      'tasks-failed': {
        one: '{n} misslyckad task de senaste 24 h',
        other: '{n} misslyckade tasks de senaste 24 h'
      },
      'storage-degraded': 'storagen {subject} degraderad',
      'storage-error': 'storagen {subject} i fel',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klustrets store onåbar',
      'license-absent': 'ingen licens — nya VM kan inte starta',
      'license-expired': 'licensen utgången — nya VM kan inte starta',
      'license-exceeded': 'licensgränsen överskriden — nya VM kan inte starta',
      'failover-reserve-eroded': 'failover-reserven nästan förbrukad',
      'failover-reserve-exhausted': 'failover-reserven uttömd — nya VM kan inte starta',

      'oci-cache-nearly-full': 'OCI-cachen på {subject} är nästan full — digester tas bort för hand',
      'oci-cache-full': 'OCI-cachen på {subject} är full — ingen pull lyckas förrän digester tas bort',
      'config-replica-empty': 'konfigurationsreplikan på {subject} är TOM — noden har ingen klusterkonfiguration förrän en replikering lyckas',
      'config-replica-stalled': 'konfigurationsreplikeringen på {subject} står stilla — den lokala kopian släpar efter klustrets konfiguration'
    },
    staleChip: 'Data inte uppdaterade',
    staleAsOf: 'senaste replika {time}',
    zone: {
      nodes: 'Noder',
      failoverReserve: 'Failover-reserv',
      capacity: 'Kapacitet',
      workload: 'Arbetslast',
      protection: 'Skydd',
      activity: 'Senaste aktivitet'
    },
    reserve: {
      state: {
        ok: 'Reserven intakt',
        eroded: 'Reserven nästan förbrukad',
        exhausted: 'Reserven uttömd',
        unknown: 'Reserven okänd'
      },
      tolerate: {
        one: 'tolererar förlust av {n} nod',
        other: 'tolererar förlust av {n} noder'
      },
      usedOf: '{used} / {allowed} GiB i bruk',
      keepFree: '{n} GiB hålls fria för failover',
      expendable: 'varav {n} som kan offras i drift',
      headroom: '{n} GiB kan fortfarande startas',
      short: 'reserven saknar {n} GiB — nya VM kan inte starta',
      hp: {
        usedOf: 'Sidor på {size} — i bruk: {used} / {allowed}',
        keepFree: 'hålls fria för failover: {keep}',
        headroom: 'kan fortfarande startas: {n}',
        short: 'saknas i reserven: {n} — nya VM med enorma sidor kan inte starta'
      },
      worstCase: 'värsta fallet: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ingen nod har ännu deklarerat sitt minne — reserven kan inte beräknas och ingen start avvisas.',
      reason: {
        attestedDown: 'attesterad avstängd',
        maintenance: 'i underhåll',
        unreachable: 'onåbar',
        capacityUnknown: 'minne inte deklarerat'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} kärnor / {threads} trådar',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktiv VM',
        other: '{n} aktiva VM'
      },
      activeVmsUnknown: 'aktiva VM okända',
      lastSeen: 'sedd {time}',
      neverSeen: 'aldrig sedd',
      down: 'Avstängd',
      maintenance: 'Underhåll',
      stale: 'Onåbar'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionerade',
      reserve: 'reserv {n} GiB',
      unobserved: 'kapacitet ännu inte observerad',
      empty: 'Ingen storage ännu'
    },
    workload: {
      vms: 'Virtuella maskiner',
      apps: 'Appar',
      services: 'Nätverkstjänster',
      empty: 'Ingen ännu',
      phasesUnknown: 'fördelning per fas inte tillgänglig'
    },
    protection: {
      none: 'Ingen backup-destination konfigurerad — skydda din konfiguration.',
      configure: 'Konfigurera checkpoints',
      noRuns: 'Ingen checkpoint har skapats ännu.',
      last: 'Senaste checkpoint',
      onTarget: 'på {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Ingen aktivitet nyligen',
      failed24: {
        one: '{n} misslyckad på 24 h',
        other: '{n} misslyckade på 24 h'
      },
      viewAll: 'Se alla tasks'
    }
  },
  notes: {
    title: 'Anteckningar',
    tabEdit: 'Redigera',
    tabPreview: 'Förhandsvisning',
    placeholder: 'Operatörens fria anteckningar — Markdown renderas i förhandsvisningen',
    empty: 'Inga anteckningar',
    tooLarge: 'Anteckningarna överskrider gränsen på 64 KiB',
    saveError: 'Kunde inte spara anteckningarna'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Svaret från backend innehåller ett värde som det här gränssnittet inte känner till: {field}={value} — uppdatera webbgränssnittet till backend-versionen.',
    contractErrorItems: '{count} objekt i den här listan kan inte läsas av det här gränssnittet ({field}={value}) och visas inte.',
    staleHint: 'Storen är inte nåbar — det här är den här nodens konfigurationsreplika; flottans tillstånd är okänt.',
    staleStateAge: 'tillstånd per {time}',
    staleStateNever: 'tillståndet har aldrig tagits emot från storen: du ser bara den här nodens egna observationer',
    staleStateTooltip: 'Klustrets store är inte nåbar: det observerade tillståndet (fas, nod, agent) kommer från den här nodens tillståndsreplika och härrör från den senaste lyckade läsningen från storen — det kan vara inaktuellt.',
    noPermission: 'Du har inte behörighet för den här åtgärden',
    actionStillRunning: 'Åtgärden pågår fortfarande — utfallet är ännu inte känt',
    staleWrite: 'Någon annan ändrade det här objektet medan du redigerade det — ingenting skrevs. Ladda om och upprepa din ändring på det färska tillståndet.',
    staleReload: 'Ladda om',
    preview: 'Förhandsgranskning',
    previewTitle: 'Förhandsgranskning av resultatet',
    previewNothingWritten: 'Simulerad på servern — inget skrevs.',
    previewChanged: 'Markerade: de värden som skulle ändras.'
  },
  context: {
    copySelection: 'Kopiera markerad text'
  },
  crud: {
    create: 'Skapa',
    viewDetails: 'Visa detaljer',
    viewOrEdit: 'Visa eller redigera',
    selected: 'valda',
    viewUsingVms: 'Se VM som använder resursen',
    clearSelection: 'Avmarkera',
    deleteSelected: 'Ta bort valda',
    bulkConfirmBody: {
      one: 'Ta bort {count} valt element? Om det är skyddat rapporteras det och behålls.',
      other: 'Ta bort de {count} valda elementen? De skyddade rapporteras och behålls.'
    },
    bulkDeleted: 'borttagna',
    bulkRefused: 'avvisade',
    fieldId: 'ID',
    createdAt: 'Skapad den',
    updatedAt: 'Uppdaterad den',
    immutableField: 'Fastslaget vid skapandet — contractet tillåter ingen ändring',
    immutableScope: 'Scopet tilldelas vid skapandet; vissa resurser flyttas med en dedikerad åtgärd',
    observedField: 'Observerat tillstånd — rapporterat av plattformen, inte redigerbart'
  }
}
